import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';

const PlatformSettingsContext = createContext();

export const usePlatformSettings = () => {
  const context = useContext(PlatformSettingsContext);
  if (!context) {
    throw new Error('usePlatformSettings must be used within PlatformSettingsProvider');
  }
  return context;
};

export const PlatformSettingsProvider = ({ children }) => {
  const [platformSettings, setPlatformSettings] = useState({
    platform_name: 'WorkStream Pro',
    logo_url: '/logo512.png',
    primary_color: '#2563EB',
    secondary_color: '#1E293B',
    accent_color: '#06B6D4'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/admin/platform-settings');
      if (response.data) {
        setPlatformSettings(response.data);
      }
    } catch (error) {
      // If error (not logged in as super admin or settings don't exist), use defaults
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <PlatformSettingsContext.Provider value={{ platformSettings, loading, refreshSettings }}>
      {children}
    </PlatformSettingsContext.Provider>
  );
};

export default PlatformSettingsContext;
